/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        const subscriptionNotice = document.getElementById('subscription-notice');
        const rcSellingPlans = document.querySelector('.rc-selling-plans');

        // Check if both elements exist
        if (subscriptionNotice && rcSellingPlans) {
    rcSellingPlans.prepend(subscriptionNotice); // Make subscriptionNotice the first child of rc-selling-plans
    subscriptionNotice.style.display = 'block'; // Remove display: none by setting display to block
    console.log('subscription-notice has been successfully added as the first child of rc-selling-plans and made visible.');
} else {
    console.log('Could not find one or both of the elements.');
}

    }, 3000); // Wait 3 seconds (3,000 milliseconds)
});




